import React, { createContext, useState, useEffect, useContext } from 'react';
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const email = localStorage.getItem('userEmail');
        return email ? { email } : null;
    });
    const [token, setToken] = useState(() => localStorage.getItem('jwtToken') || null);

    const login = (userData, authToken) => {
        setUser(userData);
        setToken(authToken);
        localStorage.setItem('jwtToken', authToken);
        localStorage.setItem('userEmail', userData.email);
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('userEmail');
    };

    // Check for token and user email in localStorage on load
    useEffect(() => {
        const storedToken = localStorage.getItem('jwtToken');
        const storedEmail = localStorage.getItem('userEmail');

        if (storedToken && storedEmail) {
            setToken(storedToken);
            setUser({ email:storedEmail }); // Restore user session
        }
    }, []);

    console.log('[UserContext] Context initialized. setUser exposed:', typeof setUser);

    return (
        <UserContext.Provider value={{ user, token, login, logout, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);